<app-spinner></app-spinner>
<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-auto">
                <h1 class="m-0 text-dark"><label>{{ localize.package_service_list }}</label></h1>
            </div>
            <!-- /.col -->
            <div *showWithRoles="[]" class="col-md-auto ml-auto">
                <button (click)="addCatalogService()" class="btn btn-primary d-inline-flex mr-3"><span
                        class="material-icons mr-1">add</span> {{ localize.add_new }}</button>
            </div>
            <!-- <!-- /.col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>

<!--MARK top bar -->
<section class="content">
    <div class="container-fluid">
        <div class="bg-white">
            <section class="p-3">
                <div class="row">
                    <div class="col-lg-3 col-md-5">
                        <div class="input-group border rounded mb-3">
                            <div class="input-group-prepend border-0">
                                <button class="btn d-inline-flex pr-2 pl-2" type="submit"><span
                                        class="material-icons">search</span></button>
                            </div>
                            <input (keyup.enter)="enterSearch()" type="text" class="form-control border-0"
                                [(ngModel)]="keySearch" placeholder="Tìm kiếm..." aria-label=""
                                aria-describedby="basic-addon1">
                        </div>
                    </div>
                    <div class="col-md-auto ml-auto">
                        
                    </div>
                </div>
            </section>
            <hr class="my-2">
            <section class="px-3 my-2">
                <form [formGroup]="formFilter">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="serviceType">{{ localize.catalog_type }}</label>
                                        <ng-select labelForId="serviceType" formControlName="serviceType" 
                                            [items]="serviceType"
                                            bindValue="value" bindLabel="label"
                                            [searchable]="false"
                                            [clearable]="false" 
                                            placeholder="{{ localize.select_catalog_type }}">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="status">{{ localize.status }}</label>
                                        <ng-select labelForId="status" formControlName="status" 
                                            [items]="statusList"
                                            bindValue="value" bindLabel="label"
                                            [searchable]="false"
                                            [clearable]="false" 
                                            placeholder="{{ localize.select_status }}">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="align-self-end mb-3 ml-auto">
                                    <button class="btn btn-outline-primary d-inline-flex mr-3" (click)="cleanFilter()">
                                        {{ localize.set_again }}
                                    </button>
                                    <button class="btn btn-primary d-inline-flex mr-3" (click)="searchWithFilter()">
                                        {{ localize.apply }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>

            <section class="card-body p-0">
                <div class="table-responsive">
                    <table class="table mb-0">
                        <thead>
                            <tr class="bg-tb-header border-top text-left">
                                <th>STT</th>
                                <th class="cursor-pointer" (click)="sortCol('name')">
                                    <app-table-sort-header [title]="localize.catalog_name" [sortColConfig]="this.sortColConfig['name']"></app-table-sort-header>
                                </th>
                                <th class="cursor-pointer" (click)="sortCol('serviceType')">
                                    <app-table-sort-header [title]="localize.catalog_type" [sortColConfig]="this.sortColConfig['serviceType']"></app-table-sort-header>
                                </th>
                                <th class="cursor-pointer" (click)="sortCol('status')">
                                    <app-table-sort-header [title]="localize.status" [sortColConfig]="this.sortColConfig['status']"></app-table-sort-header>
                                </th>
                                <th>{{ localize.action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of catalogs; let i = index">
                                <td>{{ (page - 1) * maxSize + i + 1 }}</td>
                                <td>
                                    <a class="text-primary text-decoration-underline cursor-pointer" (click)="gotoDetail(item.serviceInfoId)">{{ item.name }}</a>
                                </td>
                                <td>{{ item.typeService === 'CHUCNANG' ? localize.feature : localize.infrastructure }}</td>
                                <td>
                                    <span *ngIf="item.status == 'ENABLED'" class="badge badge-success-new p-2">{{ localize.active }}</span>
                                    <span *ngIf="item.status == 'DISABLED'" class="badge badge-danger-new p-2">{{ localize.deactive }}</span>
                                </td>
                                <td class="text-center">
                                    <div ngbDropdown container="body">
                                        <span class="material-icons cursor-pointer" ngbDropdownToggle
                                            id="settingTable">more_vert</span>
                                        <div ngbDropdownMenu class="border-0">
                                            <a ngbDropdownItem class="dropdown-item align-items-center cursor-pointer d-flex" (click)="gotoDetail(item.serviceInfoId)">
                                                <span class="material-icons text-icon-dropdown-size mr-2">info</span>
                                                Thông tin chi tiết</a>

                                            <a ngbDropdownItem class="dropdown-item align-items-center cursor-pointer d-flex" (click)="gotoEdit(item.serviceInfoId)"><span
                                                    class="material-icons text-icon-dropdown-size mr-2">edit</span>Chỉnh sửa</a>

                                            <a ngbDropdownItem class="dropdown-item align-items-center cursor-pointer d-flex" (click)="delete(item.serviceInfoId)"><span
                                                class="material-icons text-icon-dropdown-size mr-2">delete</span>{{ localize.btn_delete }}</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="bg-tb-header p-3">
                    <div class="row align-items-center">
                        <span *ngIf="totalElement == 0" class="col-md">{{ localize.no_result_were_found }}</span>
                        <span *ngIf="totalElement > 0" class="col-md">{{ this.getResultStatus() }}</span>
                        <div class="col-md">
                            <div class="d-flex justify-content-end">
                                <div class="d-flex justify-content-end align-items-center">
                                    <span class="mr-2">{{ localize.number_of_lines_displayed }}:</span>
                                    <ng-select [(ngModel)]="maxSize" [searchable]="false" [clearable]="false"
                                        placeholder="..." (change)="loadPage(1)">
                                        <ng-option [value]="10">10</ng-option>
                                        <ng-option [value]="20">20</ng-option>
                                        <ng-option [value]="30">30</ng-option>
                                    </ng-select>
                                </div>
                                <div *ngIf="totalElement > maxSize" class="pagination pages no-border-pagination ml-2">
                                    <ngb-pagination [collectionSize]="totalElement" [(page)]="page" [maxSize]="5"
                                        [rotate]="true" [ellipses]="false" [pageSize]="maxSize"
                                        (pageChange)="loadPage($event)" [boundaryLinks]="true"
                                        aria-label="Default pagination">
                                        <ng-template ngbPaginationFirst>{{ localize.head }}</ng-template>
                                        <ng-template ngbPaginationLast>{{ localize.last }}</ng-template>
                                        <ng-template ngbPaginationPrevious>&laquo;</ng-template>
                                        <ng-template ngbPaginationNext>&raquo;</ng-template>
                                        <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
                                    </ngb-pagination>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    </div>
</section>
